export function observeOnce(
    el: HTMLElement,
    options?: IntersectionObserverInit
): Promise<void> {
    return new Promise((resolve) => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                observer.disconnect();
                resolve();
            }
        }, options);
        observer.observe(el);
    });
}
